import Dialog from './src/dialog';

module.exports = Dialog;


// WEBPACK FOOTER //
// ./src/components/dialog/index.js